<template>
  <section>
    <v-row class="d-flex justify-space-between mb-4">
      <v-col cols="12" md="3">
        <v-btn @click="toggleAddCard" color="info">
          <v-icon left>{{ icons.mdiDatabasePlusOutline }}</v-icon>
          Ajouter Heure de début de récitation
        </v-btn>
      </v-col>
      <v-col cols="12" md="3" v-if="totalItems === 0">
        <v-btn @click="handleDynamicDecoupage" color="info" :disabled="loadingStates.linear">
          <v-icon left>{{ icons.mdiScissorsCutting }}</v-icon>
          Ajouter découpage dynamique
        </v-btn>
        <v-alert v-if="error_dynamic" type="error" dense class="mt-2">
          {{ error_dynamic }}
        </v-alert>
      </v-col>
    </v-row>
    <AccessibleLoaders :loading="loadingStates.linear" />
    <v-row v-if="addCard">
      <v-col cols="12">
        <v-card class="mb-6">
          <v-form ref="form" lazy-validation>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" md="8">
                  <v-autocomplete v-model="selectedVerset" :items="filteredVersetList" item-text="french_text"
                    item-value="versetId" label="Sélectionner un verset" variant="outlined" clearable
                    :return-object="true" @change="debouncedGetSousverset"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-for="(chunk, index) in textChunks" :key="index">
                <v-col cols="12" md="8">
                  <v-text-field v-model="chunk.sousVersetText" :label="`Partie ${chunk.part}`" outlined></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <vue-timepicker v-model="chunk.sousVersetStartTimeInSec" format="HH:mm:ss" manual-input
                    hide-clear-button style="margin-top: 18px"></vue-timepicker>
                </v-col>
              </v-row>
            </v-card-text>
            <v-row>
              <v-col cols="12">
                <div class="d-flex flex-row-reverse" style="margin-right: 10%">
                  <v-btn :disabled="!selectedVerset || selectedVerset.length === 0" color="info"
                    @click="dialogAddVersetStartTime = true">
                    Ajouter
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6">
      <v-card-title>Liste des Versets</v-card-title>
      <v-card-subtitle>
        <h2>Surat {{ suratName }} - Récitateur {{ recitateurName }}</h2>
      </v-card-subtitle>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Rechercher" single-line hide-details clearable
        class="pa-4" @input="debouncedSearch"></v-text-field>
      <v-data-table :search="search" :loading="loading" loading-text="Loading..." :footer-props="{
        'items-per-page-options': [50, 100, 150, 300],
      }" :headers="headersVerset" :items="ListVersetTime" class="elevation-1">

        <template v-slot:[`item.french_text`]="{ item }">
          <span class="text-truncate">{{ item.french_text }}</span>
        </template>
        <template v-slot:[`item.part`]="{ item }">
          <span class="text-truncate">Partie {{ item.part }}</span>
        </template>
        <template v-slot:[`item.startTimeInSec`]="{ item }">
          <vue-timepicker v-model="item.editTime" format="HH:mm:ss" manual-input hide-clear-button
            @input="debouncedSaveTimeEdit(item)"></vue-timepicker>
        </template>
        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="redirectToEditVersetTime(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogAddVersetStartTime" max-width="600">
      <v-card>
        <v-card-title class="text-h6">
          Êtes-vous sûr de vouloir ajouter ce verset au récitateur ?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogAddVersetStartTime = false">
            Annuler
          </v-btn>
          <v-btn color="info" text @click="processVerseDataArray">
            Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" top right>
      {{ text }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">
          Fermer
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<script>
import { maxLength } from "vuelidate/lib/validators";
import AccessibleLoaders from "@/views/loader/AccessibleLoaders.vue";
import {
  mdiDatabasePlusOutline,
  mdiScissorsCutting,
  mdiPencil,
} from "@mdi/js";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import axios from "axios";
import Constant from "@/utils/constants";
import { getAllVersetBySurate, getRecitateurById, getSouratById } from "@/views/qorani/services/services";
import { debounce } from "lodash";

export default {
  name: "VersetStartTime",
  components: { VueTimepicker, AccessibleLoaders },
  data() {
    return {
      addCard: false,
      loadingStates: {
        linear: false,
      },
      error_dynamic: "",
      suratName: "",
      recitateurName: "",
      search: "",
      currentPage: 1,
      itemsPerPage: 100,
      totalItems: 0,
      totalPages: 0,
      loading: false,
      maxCharsPerChunk: 100,
      maxWordLength: 3,
      textChunks: [],
      dialogAddVersetStartTime: false,
      endTime: "",
      selectedVerset: null,
      listVersetBySurate: [],
      ListVersetTime: [],
      headersVerset: [
        { text: "Verset en Arabe", value: "arabic_text" },
        { text: "Verset en Français", value: "french_text" },
        { text: "Verset en Anglais", value: "english_text" },
        { text: "Partie", value: "part" },
        { text: "Heure de début", value: "startTimeInSec" },
        { text: "Modifier", value: "modifier", align: "center" },
      ],
      snackbar: false,
      text: "",
      snackbarColor: "",
      icons: {
        mdiDatabasePlusOutline,
        mdiScissorsCutting,
        mdiPencil,
      },
    };
  },
  computed: {
    filteredVersetList() {
      const existingVersetIds = new Set(this.ListVersetTime.map(verset => verset.versetId));
      return this.listVersetBySurate.filter(verset => !existingVersetIds.has(verset.versetId));
    },
  },
  methods: {
    toggleAddCard() {
      this.addCard = !this.addCard;
    },
    debouncedGetSousverset: debounce(function () {
      if (!this.selectedVerset) {
        this.textChunks = [];
        return;
      }
      this.getListSousversetByVersetId();
    }, 300),
    debouncedSearch: debounce(function () {
      this.currentPage = 1;
      this.fetchVersetList();
    }, 500),
    debouncedSaveTimeEdit: debounce(function (item) {
      this.saveTimeEdit(item);
    }, 1000),
    async saveTimeEdit(item) {
      const editTimeInSeconds = this.timeObjectToSeconds(item.editTime);
      if (editTimeInSeconds === item.startTimeInSec) return;

      try {
        const response = await axios.post(`${Constant.QORANI}recitateur/editVersetStartTime`, [{
          sousVersetId: item.sousVersetId,
          versetId: item.versetId,
          recitateurId: this.$route.params.recitateurId,
          startTimeInSec: editTimeInSeconds,
          part: item.part,
          sousVersetText: item.sousVersetText || item.french_text,
          isTextChanged: true,
        }]);
        if (response.status === 200) {
          item.startTimeInSec = editTimeInSeconds;
          this.showSnackbar("Temps mis à jour avec succès", "success");
        }
      } catch (error) {
        console.error("Error updating time:", error);
        this.showSnackbar("Erreur lors de la mise à jour", "error");
      }
    },
    async fetchVersetList() {
      this.loading = true;
      this.ListVersetTime = []; // Clear existing verset list
      let page = 1;
      const itemsPerPage = 100; // Keep the same items per page as in your original code
      let allVersetsFetched = false;

      try {
        while (!allVersetsFetched) {
          const response = await axios.post(`${Constant.QORANI}verset/getSousVersetForSuratAndRecitateur`, {
            suratId: this.$route.params.suratId,
            recitateurId: this.$route.params.recitateurId,
            pageNumber: page - 1, // API expects 0-based page index
          });

          const versets = response.data.versetList.map(item => ({
            ...item,
            editTime: this.secondsToTimeObject(item.startTimeInSec),
          }));

          this.ListVersetTime = [...this.ListVersetTime, ...versets]; // Append new versets to the list

          this.totalItems = response.data.totalNbrElement;
          this.totalPages = Math.ceil(this.totalItems / itemsPerPage);

          // Check if we've fetched all pages
          if (page * itemsPerPage >= this.totalItems) {
            allVersetsFetched = true;
          } else {
            page++; // Move to the next page
          }
        }
      } catch (error) {
        console.error("Error fetching all versets:", error);
        this.showSnackbar("Erreur lors du chargement des versets", "error");
      } finally {
        this.loading = false;
      }
    },
    secondsToTimeObject(seconds = 0) {
      const validSeconds = Math.max(0, Math.floor(Number(seconds) || 0));
      return {
        HH: String(Math.floor(validSeconds / 3600)).padStart(2, "0"),
        mm: String(Math.floor((validSeconds % 3600) / 60)).padStart(2, "0"),
        ss: String(validSeconds % 60).padStart(2, "0"),
      };
    },
    timeObjectToSeconds(timeObj) {
      if (!timeObj) return 0;
      return (
        (Number(timeObj.HH) || 0) * 3600 +
        (Number(timeObj.mm) || 0) * 60 +
        (Number(timeObj.ss) || 0)
      );
    },
    async handleDynamicDecoupage() {
      this.loadingStates.linear = true;
      this.error_dynamic = "";
      try {
        const response = await axios.post(`${Constant.QORANI}recitateur/autoEditStartTime`, {
          suratId: this.$route.params.suratId,
          recitateurId: this.$route.params.recitateurId,
        });
        if (response.data.success) {
          window.location.reload();
        } else {
          this.error_dynamic = "Une erreur est survenue lors du découpage dynamique. Veuillez réessayer plus tard.";
        }
      } catch (error) {
        console.error("Error in dynamic decoupage:", error);
        this.error_dynamic = "Une erreur est survenue lors du découpage dynamique. Veuillez réessayer plus tard.";
      } finally {
        this.loadingStates.linear = false;
      }
    },
    redirectToEditVersetTime(item) {
      this.$router.push({
        name: "EditVersetStartTime",
        params: {
          versetId: item.versetId,
          recitateurId: this.$route.params.recitateurId,
        },
      });
    },
    chunkText(sousVersetText, chunkSize, versetId) {
      if (!sousVersetText || typeof chunkSize !== "number" || chunkSize <= 0) {
        return [];
      }
      const words = sousVersetText.split(/\s+/);
      const chunks = [];
      let chunk = [];
      let charCount = 0;
      let part = 1;

      for (const word of words) {
        if (charCount + word.length + chunk.length > this.maxCharsPerChunk) {
          chunks.push({
            part,
            sousVersetText: chunk.join(" "),
            sousVersetStartTimeInSec: this.endTime,
            recitateurId: this.$route.params.recitateurId,
            versetId,
          });
          chunk = [word];
          charCount = word.length;
          part++;
        } else {
          chunk.push(word);
          charCount += word.length + 1;
        }
      }

      if (chunk.length > 0) {
        chunks.push({
          part,
          sousVersetText: chunk.join(" "),
          sousVersetStartTimeInSec: this.endTime,
          recitateurId: this.$route.params.recitateurId,
          versetId,
        });
      }
      return chunks;
    },
    async getListSousversetByVersetId() {
      if (!this.selectedVerset) return;

      try {
        const response = await fetch(
          `${Constant.QORANI}sousVerset/getListSousversetByVersetId/${this.selectedVerset.versetId}`,
          { headers: { "Content-Type": "application/json" } }
        );
        const data = await response.json();

        this.textChunks = data.length > 0
          ? data.map(chunk => ({
            ...chunk,
            edit: true,
            sousVersetStartTimeInSec: this.endTime,
          }))
          : this.chunkText(this.selectedVerset.french_text, 6, this.selectedVerset.versetId);

        if (this.ListVersetTime.length > 0) {
          const lastVersetId = this.ListVersetTime[this.ListVersetTime.length - 1].versetId;
          const response = await fetch(`${Constant.QORANI}recitateur/getListVersetStartTime`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              recitateurId: this.$route.params.recitateurId,
              listVersetId: [lastVersetId],
            }),
          });
          const responseData = await response.json();
          const lastVersetTime = responseData[responseData.length - 1]?.startTime || 0;
          this.endTime = this.secondsToTimeObject(lastVersetTime);
        }
      } catch (error) {
        console.error("Error fetching sous-versets:", error);
        this.showSnackbar("Erreur lors de la récupération des sous-versets", "error");
      }
    },
    async processVerseDataArray() {
      const verseData = this.textChunks.map(chunk => ({
        ...chunk,
        recitateurId: Number(this.$route.params.recitateurId),
        sousVersetStartTimeInSec: this.timeObjectToSeconds(chunk.sousVersetStartTimeInSec),
      }));

      try {
        const response = await fetch(`${Constant.QORANI}recitateur/addVersetStartTimeToRecitateur`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(verseData),
        });
        if (response.ok) {
          window.location.reload();
        } else {
          throw new Error("Failed to add verset start time");
        }
      } catch (error) {
        console.error("Error adding verset start time:", error);
        this.showSnackbar("Erreur lors de l'ajout du verset", "error");
      }
    },
    showSnackbar(text, color) {
      this.text = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
  async created() {
    try {
      this.listVersetBySurate = await getAllVersetBySurate(this.$route.params.suratId);
      this.suratName = (await getSouratById(this.$route.params.suratId)).arabic_translated_name;
      this.recitateurName = (await getRecitateurById(this.$route.params.recitateurId)).name;
      await this.fetchVersetList(1);
    } catch (error) {
      console.error("Error during initialization:", error);
      this.showSnackbar("Erreur lors de l'initialisation", "error");
    }
  },
};
</script>